import loadable from '@loadable/component';
import { v4 as uuidv4 } from 'uuid';
const MenuCorePage = loadable(() => import(/* webpackChunkName: "menuCore" */ '@pages/panel/Menu'));
const BranchOrders = loadable(() => import(/* webpackChunkName: "BranchOrders" */ '@src/pages/panel/BranchOrders'));
const MenuDetailsCore = loadable(() => import(/* webpackChunkName: "menudetails" */ '@pages/panel/Menu/MenuDetails'));
const MenuCreateCore = loadable(() => import(/* webpackChunkName: "menucreate" */ '@pages/panel/Menu/MenuCreate'));
const AddonsGroup = loadable(() => import(/* webpackChunkName: "addonsgroup" */ '@pages/panel/Kitchen/AddonsGroup'));
const AddonsGroupDetails = loadable(() => import(/* webpackChunkName: "addonsgroupdetails" */ '@pages/panel/Kitchen/AddonsGroupDetails'));
const SignIn = loadable(() => import(/* webpackChunkName: "login" */ '@pages/Auth/Login'));
const KitchenLocations = loadable(() => import(/* webpackChunkName: "kitchenlocations" */ '@pages/panel/KitchenLocations'));
const Orders = loadable(() => import(/* webpackChunkName: "orders" */ '@pages/panel/Orders'));
const Companies = loadable(() => import(/* webpackChunkName: "companies" */ '@pages/panel/Companies'));
const Branches = loadable(() => import(/* webpackChunkName: "branches" */ '@pages/panel/Branches'));
const Employee = loadable(() => import(/* webpackChunkName: "employee" */ '@pages/panel/Employee'));
const IngredientsV2 = loadable(() => import(/* webpackChunkName: "ingredients" */ '@src/pages/panel/Ingredients'));
const Preparations = loadable(() => import(/* webpackChunkName: "preparations" */ '@pages/panel/Preparations'));
const DishesV2 = loadable(() => import(/* webpackChunkName: "dishesV2" */ '@pages/panel/Dishes'));
const Combos = loadable(() => import(/* webpackChunkName: "combos" */ '@pages/panel/Combos'));
const KitchenSettings = loadable(() => import(/* webpackChunkName: "kitchenSettings" */ '@pages/panel/KitchenSettings'));
const Utensils = loadable(() => import(/* webpackChunkName: "utensils" */ '@pages/panel/Utensils'));
const TiramizooOrders = loadable(() => import(/* webpackChunkName: "utensils" */ '@pages/panel/Tiramizoo'));
const WalletTransactions = loadable(() => import(/* webpackChunkName: "walletTransactions" */ '@pages/panel/WalletTransactions'));
const WalletUsers = loadable(() => import(/* webpackChunkName: "walletUsers" */ '@pages/panel/WalletUsers'));
const Discounts = loadable(() => import(/* webpackChunkName: "discounts" */ '@pages/panel/Discounts'));
const Campaigns = loadable(() => import(/* webpackChunkName: "campaigns" */ '@pages/panel/Campaigns'));
const CampaignForm = loadable(() => import(/* webpackChunkName: "campaignForm" */ '@pages/panel/Campaigns/CampaignForm'));
const CampaignDetails = loadable(() => import(/* webpackChunkName: "campaignDetails" */ '@pages/panel/Campaigns/CampaignDetails'));
const CampaignUsers = loadable(() => import(/* webpackChunkName: "campaignUsers" */ '@pages/panel/Campaigns/CampaignUsers'));
const Vouchers = loadable(() => import(/* webpackChunkName: "vouchers" */ '@pages/panel/Vouchers'));
const VoucherForm = loadable(() => import(/* webpackChunkName: "voucherForm" */ '@pages/panel/Vouchers/VoucherForm'));
const VoucherDetails = loadable(() => import(/* webpackChunkName: "voucherDetails" */ '@pages/panel/Vouchers/VoucherDetails'));
const VoucherUsers = loadable(() => import(/* webpackChunkName: "voucherUsers" */ '@pages/panel/Vouchers/VoucherUsers'));
const MarketingNotification = loadable(() => import(
/* webpackChunkName: "marketingNotifications" */ '@pages/panel/Notifications/MarketingNotifications'));
const MarketingNotificationLogs = loadable(() => import(
/* webpackChunkName: "marketingNotificationsLogs" */ '@pages/panel/Notifications/MarketingNotificationLogs'));
const OrderUpdateNotifications = loadable(() => import(
/* webpackChunkName: "marketingNotificationsLogs" */ '@pages/panel/Notifications/OrderUpdateNotifications'));
const Suppliers = loadable(() => import(/* webpackChunkName: "utensils" */ '@pages/panel/Suppliers'));
const PageLayoutHOC = loadable(() => import(/* webpackChunkName: "wrapper" */ '@components/layout/PageLayoutHOC'));
const CompanyLevel = loadable(() => import(/* webpackChunkName: "CompanyLevel" */ '@src/pages/panel/CompanyLevel'));
const UserLevel = loadable(() => import(/* webpackChunkName: "UserLevel" */ '@src/pages/panel/UserLevel'));
const Ratings = loadable(() => import(/* webpackChunkName: "Ratings" */ '@src/pages/panel/Ratings'));
const DishDatabase = loadable(() => import(/* webpackChunkName: "DishDatabase" */ '@src/pages/panel/DishDatabase'));
const BranchReports = loadable(() => import(/* webpackChunkName: "BranchReports" */ '@src/pages/panel/BranchReports'));
const BranchGrowth = loadable(() => import(/* webpackChunkName: "BranchGrowth" */ '@src/pages/panel/BranchGrowth'));
const TiramizooSummary = loadable(() => import(/* webpackChunkName: "BranchGrowth" */ '@src/pages/panel/TiramizooSummary'));
const WalletSummary = loadable(() => import(/* webpackChunkName: "WalletSummary" */ '@src/pages/panel/WalletSummary'));
const Invoices = loadable(() => import(/* webpackChunkName: "Invoices" */ '@src/pages/panel/Invoices'));
const InvoicesBranchList = loadable(() => import(/* webpackChunkName: "Invoices" */ '@src/pages/panel/Invoices/BranchList'));
const CompanyBranches = loadable(() => import(/* webpackChunkName: "CompanyBranches" */ '@src/pages/panel/Company/Branches'));
const CompanyEmployees = loadable(() => import(/* webpackChunkName: "CompanyEmployees" */ '@src/pages/panel/Company/Employees'));
const BoxPickup = loadable(() => import(/* webpackChunkName: "BoxPickup" */ '@src/pages/panel/BoxPickup'));
const NPS = loadable(() => import(/* webpackChunkName: "NPS" */ '@src/pages/panel/NPS'));
const DishPerformance = loadable(() => import(/* webpackChunkName: "DishPerformance" */ '@src/pages/panel/DishPerformance'));
const CommandCenter = loadable(() => import(/* webpackChunkName: "CommandCenter" */ '@src/pages/panel/CommandCenter'));
const CommandCenterSupport = loadable(() => import(/* webpackChunkName: "CommandCenterSupport" */ '@src/pages/panel/CommandCenter/Support'));
const Maya = loadable(() => import(/* webpackChunkName: "Maya" */ '@src/pages/panel/Maya'));
export var LayoutMode;
(function (LayoutMode) {
    LayoutMode[LayoutMode["panel"] = 0] = "panel";
    LayoutMode[LayoutMode["auth"] = 1] = "auth";
})(LayoutMode || (LayoutMode = {}));
const routes = [
    {
        path: '/login',
        name: 'Login',
        component: SignIn,
        title: '',
        exact: true,
        layoutMode: LayoutMode.auth,
        id: uuidv4()
    },
    {
        path: '/',
        name: 'Panel',
        layoutMode: LayoutMode.panel,
        title: 'Dashboard',
        component: PageLayoutHOC,
        role: ['ADMIN', 'SALES', 'OPERATIONS'],
        id: uuidv4(),
        routes: [
            {
                path: '/command-center',
                name: 'Command Center',
                title: 'Command Center',
                exact: true,
                component: CommandCenter,
                role: ['ADMIN', 'SALES', 'OPERATIONS', 'BRANCH_MANAGER'],
                id: uuidv4()
            },
            {
                path: '/command-center/support',
                name: 'Customer Support',
                title: 'Customer Support',
                exact: true,
                component: CommandCenterSupport,
                role: ['ADMIN', 'SALES', 'OPERATIONS', 'BRANCH_MANAGER'],
                id: uuidv4()
            },
            {
                path: '/dashboard/wallet-summary',
                name: 'Dashboard',
                title: 'Wallet Summary',
                component: WalletSummary,
                role: ['ADMIN', 'SALES', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/dashboard/company-level',
                name: 'Dashboard',
                title: 'Company Level Dashboard',
                component: CompanyLevel,
                role: ['ADMIN', 'SALES', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/dashboard/user-level',
                name: 'Dashboard',
                title: 'User Level Dashboard',
                component: UserLevel,
                role: ['ADMIN', 'SALES', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/dashboard/ratings',
                name: 'Dashboard',
                title: 'Dish Ratings',
                component: Ratings,
                role: ['ADMIN', 'SALES', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/dashboard/dish-database',
                name: 'Dashboard',
                title: 'Dish Database',
                component: DishDatabase,
                role: ['ADMIN', 'SALES', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/dashboard/dish-performance',
                name: 'Dashboard',
                title: 'Dish Performance',
                component: DishPerformance,
                role: ['ADMIN', 'SALES', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/dashboard/tiramizoo',
                name: 'Dashboard',
                title: 'Tiramizoo',
                component: TiramizooSummary,
                role: ['ADMIN', 'SALES', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/dashboard/branch/growth',
                name: 'Dashboard',
                title: 'Branch Growth',
                component: BranchGrowth,
                role: ['ADMIN', 'SALES', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/dashboard/branch/reports',
                name: 'Branch Reports',
                title: 'Branch Reports',
                component: BranchReports,
                role: ['ADMIN', 'SALES', 'OPERATIONS', 'BRANCH_MANAGER'],
                id: uuidv4()
            },
            {
                path: '/dashboard/nps',
                name: 'NPS',
                title: 'NPS',
                component: NPS,
                role: ['ADMIN', 'SALES', 'OPERATIONS', 'BRANCH_MANAGER'],
                id: uuidv4()
            },
            {
                path: '/company/branches',
                name: 'Branches',
                title: 'Branches',
                component: CompanyBranches,
                role: ['ADMIN', 'SALES', 'OPERATIONS', 'BRANCH_MANAGER'],
                id: uuidv4()
            },
            {
                path: '/company/employees/:employeeId?',
                name: 'Employee',
                title: 'Employee',
                component: CompanyEmployees,
                role: ['ADMIN', 'SALES', 'OPERATIONS', 'BRANCH_MANAGER'],
                id: uuidv4()
            },
            {
                path: '/services/kitchen-locations/:kitchenId?',
                name: 'KitchenLocations',
                title: 'Kitchen Location',
                component: KitchenLocations,
                // exact: true,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/services/orders',
                name: 'Orders',
                title: 'Orders',
                component: Orders,
                // exact: true,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/services/discounts',
                name: 'Discounts',
                title: 'Discounts',
                component: Discounts,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/services/vouchers',
                name: 'Vouchers',
                title: 'Vouchers',
                component: Vouchers,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/marketing/campaigns',
                name: 'Campaigns',
                title: 'Campaigns',
                exact: true,
                component: Campaigns,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/marketing/campaigns/new',
                name: 'Campaigns',
                title: 'Create Campaign',
                exact: true,
                component: CampaignForm,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/marketing/campaigns/:campaignId',
                name: 'Campaigns',
                title: 'Campaign Details',
                exact: true,
                component: CampaignDetails,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/marketing/campaigns/:campaignId/users',
                name: 'Campaigns',
                title: 'Campaign Users',
                exact: true,
                component: CampaignUsers,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/marketing/vouchers',
                name: 'Vouchers',
                title: 'Vouchers',
                exact: true,
                component: Vouchers,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/marketing/vouchers/new',
                name: 'Vouchers',
                title: 'Create Voucher',
                exact: true,
                component: VoucherForm,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/marketing/vouchers/:voucherId',
                name: 'Vouchers',
                title: 'Voucher Details',
                exact: true,
                component: VoucherDetails,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/marketing/vouchers/:voucherId/edit',
                name: 'Vouchers',
                title: 'Edit Voucher',
                exact: true,
                component: VoucherForm,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/marketing/vouchers/:voucherId/users',
                name: 'Vouchers',
                title: 'Voucher Users',
                exact: true,
                component: VoucherUsers,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/services/wallet/users',
                name: 'Wallet Employees',
                title: 'Wallet Employees',
                exact: true,
                component: WalletUsers,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/services/wallet/transactions',
                name: 'Wallet Transactions',
                title: 'Wallet Transactions',
                exact: true,
                component: WalletTransactions,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/services/invoices',
                name: 'Invoices',
                title: 'Invoices',
                exact: true,
                component: Invoices,
                role: ['ADMIN'],
                id: uuidv4()
            },
            {
                path: '/services/invoices/:type',
                name: 'Invoices',
                title: 'Invoices Generation',
                exact: true,
                component: InvoicesBranchList,
                role: ['ADMIN'],
                id: uuidv4()
            },
            {
                path: '/services/box-pickup',
                name: 'Box Pickup',
                title: 'Box Pickup',
                exact: true,
                component: BoxPickup,
                role: ['ADMIN'],
                id: uuidv4()
            },
            {
                path: '/companies/:branches(branches)',
                name: 'Companies',
                title: 'Companies',
                exact: true,
                component: Companies,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/companies/employees/:employeeId?',
                name: 'Employees',
                title: 'Employees',
                component: Employee,
                // exact: true,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/companies/:companyId/:branchId?',
                name: 'Branch',
                title: 'Branches',
                component: Branches,
                exact: true,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/kitchen/branch-orders',
                name: 'Branch Orders',
                title: 'Branch Orders',
                component: BranchOrders,
                exact: true,
                role: ['ADMIN', 'OPERATIONS', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/kitchen/ingredients/:ingredientId?',
                name: 'Ingredients',
                title: 'Ingredients',
                component: IngredientsV2,
                // exact: true,
                role: ['ADMIN', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/kitchen/preparations/:prepId?',
                name: 'Preparations',
                title: 'Preparations',
                component: Preparations,
                // exact: true,
                role: ['ADMIN', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/kitchen/utensils/:utensilId?',
                name: 'Utensils',
                title: 'Utensils',
                component: Utensils,
                // exact: true,
                role: ['ADMIN', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/kitchen/dishes/:dishId?',
                name: 'Dishes',
                title: 'Dishes',
                component: DishesV2,
                // exact: true,
                role: ['ADMIN', 'OPERATIONS', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/kitchen/combos/:comboId?',
                name: 'Combos',
                title: 'Combos',
                component: Combos,
                role: ['ADMIN', 'OPERATIONS', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/kitchen/menus',
                name: 'Menus',
                title: 'Menus',
                component: MenuCorePage,
                exact: true,
                role: ['ADMIN', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/kitchen/menus/create',
                name: 'Menus',
                title: 'Menus',
                component: MenuCreateCore,
                exact: true,
                role: ['ADMIN', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/kitchen/menus/:menuId',
                name: 'Menus',
                title: 'Menus',
                component: MenuDetailsCore,
                exact: true,
                role: ['ADMIN', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/kitchen/addonsGroup',
                name: 'Addons Group',
                title: 'Addons Group',
                component: AddonsGroup,
                exact: true,
                role: ['ADMIN', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/kitchen/settings',
                name: 'Settings',
                title: 'Settings',
                component: KitchenSettings,
                exact: true,
                role: ['ADMIN'],
                id: uuidv4()
            },
            {
                path: '/kitchen/addonsGroup/:addonGroupId',
                name: 'Addons Group',
                title: 'Addons Group',
                component: AddonsGroupDetails,
                exact: true,
                role: ['ADMIN', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/users',
                name: 'Users',
                title: 'Users',
                exact: true,
                component: Employee,
                role: ['ADMIN'],
                id: uuidv4()
            },
            {
                path: '/tiramizoo',
                name: 'Tiramizoo Orders',
                title: 'Tiramizoo Orders',
                exact: true,
                component: TiramizooOrders,
                role: ['ADMIN', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/notifications/marketing',
                name: 'Marketing Notifications',
                title: 'Marketing Notifications',
                component: MarketingNotification,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/notifications/sent',
                name: 'Sent Notifications',
                title: 'Sent Notifications',
                component: MarketingNotificationLogs,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/notifications/orderupdate',
                name: 'Order Update Notifications',
                title: 'Order Update Notifications',
                component: OrderUpdateNotifications,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            },
            {
                path: '/suppliers',
                name: 'Suppliers',
                title: 'Suppliers',
                component: Suppliers,
                role: ['ADMIN', 'OPERATIONS'],
                id: uuidv4()
            },
            {
                path: '/maya',
                name: 'Maya',
                title: 'Maya',
                exact: true,
                component: Maya,
                role: ['ADMIN', 'SALES'],
                id: uuidv4()
            }
        ]
    }
];
export default routes;
